export interface CaixaAbertoModel {
  idPdvCaixa: number;
  pdv: string;
  operador: string;
  unidade: number;
  dataAbertura: string;
  horaAbertura: string;
  minutosAberto: number;
  previsto: number;
  realizado: number;
}

export class AgoraKpisModel {
  caixasAbertos: number;
  totalPrevistoAberto: number;
  totalRealizadoAberto: number;
}

export class AgoraModel {
  kpis: AgoraKpisModel;
  caixasAbertos: CaixaAbertoModel[];
}

export function emptyAgora(): AgoraModel {
  return {
    kpis: { caixasAbertos: 0, totalPrevistoAberto: 0, totalRealizadoAberto: 0 },
    caixasAbertos: [],
  };
}
